import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "category": "Category",
      "category-top": "Top Slots",
      "category-asia": "Asia",
      "category-fruits": "Fruits",
      "category-adventure": "Adventure",
      "category-festivity": "Festivity",
      "clear-filters": "Clear all filters",
      "tags": "Tags",
      "show-more-slots": "Show More Slots",
      "back-to-top": "Back to top"
    }
  },
  es: {
    translation: {
      "category": "Categorias",
      "category-top": "Top Slots",
      "category-asia": "Asia",
      "category-fruits": "Frutas",
      "category-adventure": "Aventuras",
      "category-festivity": "Festividades",
      "clear-filters": "Borrar filtros",
      "tags": "Tags",
      "show-more-slots": "Ver más Slots",
      "back-to-top": "Volver arriba"
    }
  },
  ru: {
    translation: {
      "category": "Категория",
      "category-top": "Топ Игры",
      "category-asia": "Азия",
      "category-fruits": "Фрукты",
      "category-adventure": "Приключения",
      "category-festivity": "Праздники",
      "clear-filters": "Очистить все фильтры",
      "tags": "Теги",
      "show-more-slots": "Больше Слотов",
      "back-to-top": "Вернуться к началу"
    }
  },
};

const languageDetector = new LanguageDetector(null, {
  order: ['htmlTag', 'path', 'subdomain', 'querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator'],
});
i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'es', 'ru'],

    fallbackLng: 'en',
    debug: true,
    resources: resources,

    interpolation: {
      escapeValue: false,
    }
  });


export default i18n;
